<template>
    <div class="container search-back" v-if="hasSearchHistory">
        <!-- <div class="container search-back" > -->
        <div class="row">
            <div class="col-12">
                <a href="#" @click.prevent="goBackToSearch()" class="btn btn-search-back">
                    <span>{{getText()}}</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import SearchHistoryService from '@/services/searchHistoryService';
import { onBeforeMount} from 'vue';

const dictionary = {
    'Back_to_product': 'Zurück zum Produkt',
    'Back_to_search': 'Zurück zur Suche',
    'Back_to_overview': "Zurück zur Übersicht",
}

let hasSearchHistory = false;
let searchType = "";

onBeforeMount(()=> {
    hasSearchHistory = SearchHistoryService.Instance.checkSearchHistory();    
    searchType = SearchHistoryService.Instance.getHistoryType();
});

const goBackToSearch = ():void =>{
        SearchHistoryService.Instance.setHistoryMark();
        window.history.back();
    }
function getText(){
    switch(searchType){
        case "praeparat":
        case "praeparatSearch":
            return dictionary["Back_to_product"];
        case "content":
            return dictionary["Back_to_search"];
        default:
            return dictionary["Back_to_overview"];
    }
}
</script>